import React,{useState} from "react";
import { CollapseArrow } from "~/assets/svg/InterfaceIcon";
const CollaseibleFQA = ({question,answer}) =>{
    const [isOpen , setIsOpen] = useState(false);
     return (
         <div className={isOpen ? "faq-item" : "faq-item card-close"}>
					<div className="faq-card-header">
						<button type="button" className="faq-item-header" onClick = {() => setIsOpen(!isOpen)} >
							<CollapseArrow/>
							{question}
						</button>
					</div>
					<div className="faq-answer">
						<p className="card-answer-line">
							{answer}
						</p>
					</div>
				</div>
    )
}

export default CollaseibleFQA;
